<template>
  <div class="static-view" :class="{ 'lager-view': fullscreen }">
    <div class="static-view-header">
      <div class="static-view-header-content">
        <div class="header-title">运维数据可视化大屏</div>
        <div class="header-line"></div>
      </div>
    </div>
    <div class="static-view-echarts echarts">
      <div class="mapLeft">
        <div class="mapLeftTop">
          <div class="title">
            报名增长数前五的考点
            <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
          </div>
          <div id="chart1" class="chart1"></div>
        </div>
        <div class="mapLeftMiddle">
          <div class="title">
            最近6个月的每月考点新增数
            <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
          </div>
          <div id="chart2" class="chart2"></div>
        </div>
        <div class="mapLeftBottom">
          <div>
            <div class="title">
              各省报名占比情况
              <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
            </div>
            <div id="chart3" class="chart3"></div>
          </div>
          <div>
            <div class="title1">
              各市报名占比情况
              <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
            </div>
            <div id="chart4" class="chart4"></div>
          </div>
        </div>
      </div>
      <div class="mapMiddle">
        <div style="height: 600px">
          <div class="select-box">
            <el-select
              v-model="query.nf"
              @change="yearChange"
              filterable
              placeholder="请选择"
              class="custom-select"
            >
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label + '年'"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              style="margin-left: 60px"
              v-model="query.kspc"
              filterable
              @change="kspcChange"
              class="custom-select"
            >
              <el-option label="全部批次" value=""></el-option>
              <el-option
                v-for="item in kspcList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div v-if="isBack" class="back" @click="back">
              <img src="../../../assets/img/back.png" alt="" />
              <span>返回全国地图</span>
            </div>
          </div>
          <div v-if="isShow" id="map" class="map"></div>
        </div>
        <div class="mapMiddleFooter" v-if="centreData.score">
          <div class="footerBtn">
            <div class="text-container">
              <div>{{ centreData.score }}万元</div>
              <div style="margin-top: 10px">缴费总金额</div>
            </div>
          </div>
          <div class="footerBtn" v-if="centreData.kdzs">
            <div class="text-container">
              <div>{{ centreData.kdzs }}个</div>
              <div style="margin-top: 10px">考点总数</div>
            </div>
          </div>
          <div class="footerBtn" v-if="centreData.kszs">
            <div class="text-container">
              <div>{{ centreData.kszs }}人</div>
              <div style="margin-top: 10px">考生总人数</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mapRight">
        <div class="mapRightTop">
          <div class="title">
            最近6个月的每月缴费总金额
            <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
          </div>
          <div id="chart5" class="chart5"></div>
        </div>
        <div class="mapRightMiddle">
          <div class="title">
            各省缴费总金额
            <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
          </div>
          <div id="chart6" class="chart6"></div>
        </div>
        <div class="mapRightBottom">
          <div class="title">
            各市缴费总金额
            <img class="title-img" src="../../../assets/img/dataText.png" alt="" />
          </div>
          <div id="chart7" class="chart7"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts/map/js/china';
export default {
  name: 'dataReport',
  data() {
    return {
      query: {
        nf: null,
        kspc: '',
      },
      yearList: [], //年份集合
      kspcList: [
        { value: '1', label: '春季' },
        { value: '2', label: '夏季' },
        { value: '3', label: '秋季' },
        { value: '4', label: '冬季' },
      ],
      isShow: true,
      legendList: [],
      enrollmentYear: '',
      fullscreen: false,
      teleport: true,
      mapEChart: null, //地图
      chinaDatas: [], //地图数据
      columnEChart: null, //柱状图
      rowEChart: null, //横向柱状图
      pieEChart: null, //饼图
      centreData: {},
      site: [],
      month: [],
      monthScore: [],
      provinceScore: [],
      cityScore: [],
      provincePercent: [],
      cityPercent: [],
      allProvince: [],
      isBack: false,
    };
  },
  async mounted() {
    const chartElement = document.getElementById('chart1');
    if (chartElement) {
      this.getData();
      this.getCentreData();
      // this.initMapDta();
      // this.initBar();
      // this.initRow()
      // this.initPie();
      // this.initPie1();
      // this.initLine();
      // this.initBar1();
      // this.initBar2();
    }
    await this.getYearList();
    const provinceFiles = require.context('echarts/map/js/province', false, /\.js$/);

    provinceFiles.keys().forEach((fileName) => {
      provinceFiles(fileName);
      // 这里可以调用 ECharts 的相关方法来使用加载的地图
    });
  },
  methods: {
    yearChange(val) {
      this.isShow = false;
      this.getMap();
    },
    back() {
      this.initMapDta(true);
    },
    kspcChange(val) {
      this.isShow = false;
      this.getMap();
    },
    toggle() {
      this.fullscreen = !this.fullscreen;
      // setTimeout(() => {
      //   this.mapEChart.resize();
      //   this.columnEChart.resize();
      //   this.lineEChart.resize();
      // }, 200);
    },
    async getYearList() {
      this.$axios.get('/examInformation/selectFilterData').then((res) => {
        this.yearList = res.data.data;
        if (this.yearList && this.yearList.length > 0) {
          let year = new Date().getFullYear();
          this.query.nf = year + '';
        }
        this.getMap();
      });
    },
    getCentreData() {
      this.$axios.get(`/data/centre?nf=&kspc=`).then((res) => {
        this.centreData = res.data.data;
      });
    },
    getMap() {
      let nf = this.query.nf;
      let kspc = this.query.kspc;
      this.$axios
        .get(`/data/allProvince?nf=${nf}&kspc=${kspc}`)
        .then((res) => {
          this.allProvince = res.data.data;

          this.isShow = true;
          this.$nextTick(() => {
            // 确保 DOM 更新后再执行
            this.initMapDta();
          });
        })
        .catch((err) => {
          this.isShow = true;
          this.$nextTick(() => {
            // 确保 DOM 更新后再执行
            this.initMapDta();
          });
        });
    },
    async initMapDta(flag = false) {
      let allProvince = this.allProvince;
      function normalizeName(name) {
        return name
          .replace(/市$/, '') // 去掉“市”后缀
          .replace(/省$/, '') // 去掉“省”后缀
          .replace(/自治区$/, '') // 去掉“自治区”后缀
          .replace(/特别行政区$/, '') // 去掉“特别行政区”后缀
          .replace(/回族$/, '') // 去掉“回族自治区”后缀
          .replace(/壮族$/, '')
          .replace(/维吾尔$/, '');
      }

      // 标准化名称
      allProvince = allProvince.map((item) => {
        return {
          ...item,
          name: normalizeName(item.name),
          value: item.score,
        };
      });
      console.log('allProvince', allProvince);
      let option = {
        backgroundColor: 'transparent',
        geo: {
          map: 'china',
          zoom: 1.0,
          label: {
            show: true, // 显示省份名称
            color: '#fff', // 省份名称颜色
            fontSize: 12, // 省份名称字体大小
          },
          roam: true,
          itemStyle: {
            normal: {
              color: '#285079',
              borderColor: 'rgba(147, 235, 248, 1)',
              borderWidth: 1,
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(147, 235, 248, 0)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(147, 235, 248, .2)',
                  },
                ],
                globalCoord: false,
              },
              shadowColor: 'rgba(128, 217, 248, 1)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10,
            },
            emphasis: {
              color: 'rgba(128, 217, 248, .5)',
            },
          },
        },
        tooltip: {
          show: true,
          formatter: (params) => {
            if (params.data) {
              return `${params.name}<br>缴费总金额：${params.data.score}万元<br>考点总数：${params.data.kdzs}个<br>考生总人数：${params.data.kszs}人`;
            }
            return '';
          },
        },
        visualMap: {
          type: 'continuous',
          text: ['', ''],
          showLabel: false,
          left: '50',
          min: 0,
          max: 100,
          inRange: {
            color: ['rgba(128, 217, 248, .5)', '#b7d6f3', '#40a9ed', '#3598c1', '#215096'],
          },
          splitNumber: 0,
          show: false, // 添加这一行来隐藏指标
        },
        series: [
          {
            name: 'MAP',
            type: 'map',
            geoIndex: 0, // 指定使用第一个 geo 配置
            label: {
              normal: {
                show: true,
              },
              emphasis: {
                show: true,
              },
            },
            data: allProvince,
          },
        ],
      };
      this.mapEChart = echarts.init(document.getElementById('map'));
      this.mapEChart.setOption(option, true);
      const provinceCoordinates = {
        安徽: [117.283, 31.8612], // 安徽省
        北京: [116.4074, 39.9042], // 北京市
        重庆: [106.5516, 29.563], // 重庆市
        福建: [119.2965, 26.1002], // 福建省
        甘肃: [103.8343, 36.0611], // 甘肃省
        广东: [113.2806, 23.1252], // 广东省
        广西: [108.32, 23.4091], // 广西壮族自治区
        贵州: [106.7135, 26.5783], // 贵州省
        海南: [110.3312, 20.0319], // 海南省
        河北: [115.4823, 38.1615], // 河北省
        黑龙江: [126.6425, 45.7569], // 黑龙江省
        河南: [113.6654, 34.757], // 河南省
        湖北: [114.2986, 30.5844], // 湖北省
        湖南: [113.0823, 28.1941], // 湖南省
        江苏: [118.7674, 32.0415], // 江苏省
        江西: [115.8922, 28.6765], // 江西省
        吉林: [126.2622, 43.8975], // 吉林省
        辽宁: [123.4291, 41.7968], // 辽宁省
        内蒙古: [111.6704, 40.8183], // 内蒙古自治区
        宁夏: [106.2782, 38.4664], // 宁夏回族自治区
        青海: [95.7129, 36.62], // 青海省
        陕西: [108.948, 34.2632], // 陕西省
        山东: [117.0009, 36.6758], // 山东省
        上海: [121.4737, 31.2304], // 上海市
        山西: [112.549, 37.8572], // 山西省
        四川: [104.0658, 30.6594], // 四川省
        天津: [117.2108, 39.1439], // 天津市
        新疆: [87.2985, 43.7785], // 新疆维吾尔自治区
        西藏: [91.1322, 29.6604], // 西藏自治区
        云南: [102.7123, 25.0406], // 云南省
        浙江: [120.1536, 29.2852], // 浙江省
        香港: [114.1694, 22.3193], // 香港特别行政区
        澳门: [113.5491, 22.1987], // 澳门特别行政区
      };
      let nf = this.query.nf;
      let kspc = this.query.kspc;
      // 存储原始全国配置
      const originalOption = JSON.parse(JSON.stringify(option));
      if (flag) {
        this.mapEChart.setOption(originalOption);
        this.isBack = false;
        return;
      }
      // 添加点击事件监听
      this.mapEChart.on('click', async (params) => {
        if (params.componentType === 'series') {
          const provinceName = params.name;
          const provinceMap = provinceName.toLowerCase(); // 省份地图名称
          const centerCoordinates = provinceCoordinates[provinceName] || [104.0, 35.0]; // 默认坐标

          // 判断点击的是省份还是城市
          if (params.data && params.data.isCity) {
            // 点击的是城市
            let resData = await this.$axios.get(`/data/county/${params.data.code}`);
            const geoJson = JSON.parse(resData.data.data);
            console.log('geoJson', geoJson);
            const cityName = params.name;
            echarts.registerMap(cityName, geoJson);

            try {
              // 获取市级数据
              const cityData = await this.$axios.get(
                `/data/allCounties/${params.data.code}?nf=${nf}&kspc=${kspc}`
              );
              const allDistricts = cityData.data.data.map((item) => ({
                ...item,
                name: item.name,
                value: item.score,
                isDistrict: true, // 标记为区县数据
              }));
              console.log('geoJson.features[0].properties', geoJson.features[0].properties);

              // 切换到区县地图
              const districtOption = {
                ...originalOption,
                geo: {
                  ...originalOption.geo,
                  map: cityName, // 使用城市名称
                  zoom: 1, // 适当放大
                  center: geoJson.features[0].properties.center,
                  itemStyle: {
                    ...originalOption.geo.itemStyle,
                    areaColor: '#215096', // 调整底色
                  },
                },
                series: [
                  {
                    ...originalOption.series[0],
                    data: allDistricts, // 使用区县数据
                  },
                ],
                tooltip: {
                  show: true,
                  formatter: (params) => {
                    if (params.data) {
                      return `${params.name}<br>缴费总金额：${params.data.score}万元<br>考点总数：${params.data.kdzs}个<br>考生总人数：${params.data.kszs}人`;
                    }
                    return '';
                  },
                },
              };
              this.isBack = true;
              this.mapEChart.setOption(districtOption);
              this.mapEChart.resize(); // 确保地图正确渲染
            } catch (error) {
              console.error(`切换到 ${cityName} 地图失败:`, error);
            }
          } else {
            // 点击的是省份
            if (echarts.getMap(provinceMap)) {
              this.$axios
                .get(`/data/allCity/${params.data.code}?nf=${nf}&kspc=${kspc}`)
                .then((res) => {
                  const allCity = res.data.data.map((item) => ({
                    ...item,
                    name: item.name,
                    value: item.score,
                    isCity: true, // 标记为城市数据
                    province: provinceName, // 添加省份信息
                  }));

                  const provinceOption = {
                    ...originalOption,
                    geo: {
                      ...originalOption.geo,
                      map: provinceMap,
                      zoom: 1.2,
                      center: centerCoordinates,
                      itemStyle: {
                        ...originalOption.geo.itemStyle,
                        areaColor: '#215096',
                      },
                    },
                    series: [
                      {
                        ...originalOption.series[0],
                        data: allCity,
                      },
                    ],
                    tooltip: {
                      show: true,
                      formatter: (params) => {
                        if (params.data) {
                          return `${params.name}<br>缴费总金额：${params.data.score}万元<br>考点总数：${params.data.kdzs}个<br>考生总人数：${params.data.kszs}人`;
                        }
                        return '';
                      },
                    },
                  };
                  this.isBack = true;
                  this.mapEChart.setOption(provinceOption);
                });
            } else {
              console.warn(`没有找到 ${provinceName} 的地图数据`);
              this.isBack = false;
              this.mapEChart.setOption(originalOption);
            }
          }
        }
      });
    },
    getData() {
      this.$axios.get(`/data/site`).then((res) => {
        this.site = res.data.data;
        this.initBar();
      });
      this.$axios.get(`/data/month`).then((res) => {
        this.month = res.data.data;
        this.initRow();
      });
      this.$axios.get(`/data/monthScore`).then((res) => {
        this.monthScore = res.data.data;
        this.initLine();
      });
      this.$axios.get(`/data/provinceScore`).then((res) => {
        this.provinceScore = res.data.data;
        this.initBar1();
      });
      this.$axios.get(`/data/cityScore`).then((res) => {
        this.cityScore = res.data.data;
        this.initBar2();
      });
      this.$axios.get(`/data/provincePercent`).then((res) => {
        this.provincePercent = res.data.data;
        this.initPie();
      });
      this.$axios.get(`/data/cityPercent`).then((res) => {
        this.cityPercent = res.data.data;
        this.initPie1();
      });
    },
    initBar() {
      let dataName = [];
      let data = [];
      this.site.forEach((item) => {
        dataName.push(item.label);
        data.push(item.value);
      });
      var option = (option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            // 获取当前悬停的系列数据
            var tooltipContent = params
              .map((item) => {
                return `${item.value} 个`; //
              })
              .join('<br/>');
            return tooltipContent;
          },
        },
        grid: {
          top: '8%',
          right: '5%',
          left: '8%',
          bottom: '40%',
        },
        xAxis: [
          {
            type: 'category',
            data: dataName,
            axisLine: {
              lineStyle: {
                color: '#50637A',
              },
            },
            axisLabel: {
              formatter: function (value) {
                return value.length > 8 ? value.slice(0, 8) + '...' : value; // 截断长标签
              },
              margin: 10,
              color: '#ffffff',
              textStyle: {
                fontSize: 13,
              },
              interval: 0, // 显示所有标签
              rotate: this.site.length > 3 ? 45 : 0, // 标签旋转角度
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '个',
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 14,
              align: 'right',
              padding: 5,
            },
            axisLabel: {
              formatter: '{value}',
              color: '#ffffff',
              fontSize: 14,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(173, 216, 230, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            type: 'bar',
            data: data,
            barWidth: '12px',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5DBBF2',
                },
                {
                  offset: 1,
                  color: '#4293FD',
                },
              ]),
              barBorderRadius: [12, 12, 0, 0], // 设置顶部为半圆
            },
          },
        ],
      });

      this.columnEChart = echarts.init(document.getElementById('chart1'));
      this.columnEChart.setOption(option, true);
    },
    initRow() {
      let dataName = [];
      let data1 = [];
      let defaultData = [];
      let maxData = 0;
      this.month.forEach((item) => {
        dataName.push(item.label);
        data1.push(item.value);
        if (maxData < +item.value) {
          maxData = +item.value;
        }
      });
      // 处理 maxData，使其符合要求
      function adjustMaxData(value) {
        let nextMultipleOf50 = Math.ceil(value / 50) * 50; // 向上取整到下一个 50 的倍数
        return nextMultipleOf50;
      }

      // 调整 maxData
      maxData = adjustMaxData(maxData);
      console.log('maxData', maxData);
      for (let i = 0; i < data1.length; i++) {
        defaultData.push(maxData);
      }
      var colorList = [
        '#00AAFF',
        '#A52A2A',
        '#FF752D',
        '#FFCF31',
        '#FF3129',
        '#006400',
        '#8B4513',
        '#FF8C00',
        '#FFB6C1',
        '#7B68EE',
        '#87CEFA',
        '#008000',
        '#D2B48C',
      ];
      let option = {
        backgroundColor: 'transparent',
        grid: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '0',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          position: function (point, params, dom, rect, size) {
            // console.log(point)

            return [point[0], point[1]];
          },
          confine: false,
          // formatter: '{b}:{c}'
          formatter: function (params) {
            // let title = params[0].name;
            // if (title.length > 30) {
            //   title = title.substring(0, 15) + '<br/>' + title.substring(15, 30) + '<br/>' + title.substring(30);
            // } else if (title.length > 15) {
            //   title = title.substring(0, 15) + '<br/>' + title.substring(15);
            // }
            let name = params[0].value + '个';
            return name;
          },
        },
        // backgroundColor: 'rgb(20,28,52)',
        xAxis: {
          show: false,
          type: 'value',
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            // axisLabel: {
            //   show: true,
            //   textStyle: {
            //     color: '#fff'
            //   },
            //   rotate: 0
            // },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              formatter: '{value}',
              color: '#ffffff',
              fontSize: 14,
            },
            data: dataName,
          },
          {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: '12',
              },
              formatter: function (value) {
                return value + '个';
              },
            },
            data: data1,
          },
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: [0, 30, 30, 0],
                color: (params) => {
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {
                      offset: 0,
                      color: 'rgba(54,69,129,1)',
                    },
                    {
                      offset: 0.8,
                      color: colorList[params.dataIndex],
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,255,255,0.8)',
                    },
                  ]);
                },
                // color: (params) => {
                //   return colorList[params.dataIndex]
                // }
              },
            },
            barWidth: 10,
            data: data1,
          },
          {
            name: '背景',
            type: 'bar',
            barWidth: 10,
            barGap: '-100%',
            data: defaultData,
            itemStyle: {
              normal: {
                color: '#1B375E',
                barBorderRadius: [0, 30, 30, 0],
              },
            },
          },
        ],
      };
      this.rowEChart = echarts.init(document.getElementById('chart2'));
      this.rowEChart.setOption(option, true);
    },
    initPie() {
      let data = this.provincePercent.map((item) => {
        return {
          name: item.label,
          value: item.value,
        };
      });
      const backgroundColor = 'transparent';
      const title = {
        text: '',
        textStyle: {
          color: '#fff',
          fontSize: 16,
        },
        padding: 0,
        top: 35,
        left: 'center',
      };
      const legend = {
        //data，就是取得每个series里面的name属性。2324
        show: false, // 设置为 false 隐藏图例
        orient: 'vertical',
        icon: 'circle', //图例形状
        padding: 0,
        bottom: 'center',
        right: 40,
        itemWidth: 14, //小圆点宽度
        itemHeight: 14, // 小圆点高度
        itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
        textStyle: {
          fontSize: 15,
          color: '#ffffff',
        },
      };
      const tooltip = {
        show: true,
        formatter: '{b}:{d}%',
      };
      const color = ['#03acd1', '#04cab7', '#03c781', '#fce348', '#0292fe', '#fc2d8a'];
      let option = {
        backgroundColor,
        color,
        title,
        tooltip,
        legend,
        series: [
          {
            name: '',
            type: 'pie',
            center: ['50%', '50%'], //圆心的位置
            top: '2%', //单单指的饼图距离上面的距离，top越大饼图越小
            left: '0%', //单单指的饼图距离左面的距离，会改变饼图的大小
            radius: ['0%', '88%'], //实心圆[内半径=0，外半径] 外半径越大，圆越大
            clockwise: true, //顺时针排列
            startAngle: 90, //起始角度 影响不大
            //roseType:"", // 实心圆 不能出现roseType这个属性
            label: {
              show: true, //false不显示饼图上的标签
              position: 'inside', //inside（在饼图上显示）,outside(默认就会出现引导线) center
              // formatter: '{b}:{c}',
              formatter: '{b}:{d}%', // 显示百分比
              textStyle: {
                fontSize: 10, // 设置标签字体大小
                rotate: 45,
              },
            },
            //只有设置了label:show=ture;position=outside 设置labelLine才会有效
            labelLine: {
              show: false, //显示引导线
              length: 30, //连接饼图第1段线条的长度 length length2 不写自适应
              length2: 30, //链接饼图第2段线条长度
              smooth: false, //是否光滑连接线
            },
            itemStyle: {
              //每个扇形的设置
              borderColor: 'rgba(0,0,0,.1)', //扇形边框颜色
              borderWidth: 1, //扇形边框大小 要先给borderColor颜色 设置borderWidth才会有效果
            },
            data: data.sort((a, b) => b.value - a.value), //数组从大到小排序

            emphasis: {
              //启用鼠标放上去放大效果，这个挺好的
              scale: true,
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      this.pieEChart = echarts.init(document.getElementById('chart3'));
      this.pieEChart.setOption(option, true);
    },
    initPie1() {
      let data = this.cityPercent.map((item) => {
        return {
          name: item.label,
          value: item.value,
        };
      });
      const backgroundColor = 'transparent';
      const title = {
        text: '',
        textStyle: {
          color: '#fff',
          fontSize: 16,
        },
        padding: 0,
        top: 35,
        left: 'center',
      };
      const legend = {
        //data，就是取得每个series里面的name属性。2324
        show: false, // 设置为 false 隐藏图例
        orient: 'vertical',
        icon: 'circle', //图例形状
        padding: 0,
        bottom: 'center',
        right: 40,
        itemWidth: 14, //小圆点宽度
        itemHeight: 14, // 小圆点高度
        itemGap: 21, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
        textStyle: {
          fontSize: 15,
          color: '#ffffff',
        },
      };
      const tooltip = {
        show: true,
        formatter: '{b}:{d}%',
      };
      const color = ['#03acd1', '#04cab7', '#03c781', '#fce348', '#0292fe', '#fc2d8a'];
      let option = {
        backgroundColor,
        color,
        title,
        tooltip,
        legend,
        series: [
          {
            name: '',
            type: 'pie',
            center: ['50%', '50%'], //圆心的位置
            top: '2%', //单单指的饼图距离上面的距离，top越大饼图越小
            left: '0%', //单单指的饼图距离左面的距离，会改变饼图的大小
            radius: ['0%', '88%'], //实心圆[内半径=0，外半径] 外半径越大，圆越大
            clockwise: true, //顺时针排列
            startAngle: 90, //起始角度 影响不大
            //roseType:"", // 实心圆 不能出现roseType这个属性
            label: {
              show: true, //false不显示饼图上的标签
              position: 'inside', //inside（在饼图上显示）,outside(默认就会出现引导线) center
              // formatter: '{b}:{c}',
              formatter: '{b}:{d}%', // 显示百分比
              textStyle: {
                fontSize: 10, // 设置标签字体大小
                rotate: 45,
              },
            },
            //只有设置了label:show=ture;position=outside 设置labelLine才会有效
            labelLine: {
              show: false, //显示引导线
              length: 30, //连接饼图第1段线条的长度 length length2 不写自适应
              length2: 30, //链接饼图第2段线条长度
              smooth: false, //是否光滑连接线
            },
            itemStyle: {
              //每个扇形的设置
              borderColor: 'rgba(0,0,0,.1)', //扇形边框颜色
              borderWidth: 1, //扇形边框大小 要先给borderColor颜色 设置borderWidth才会有效果
            },
            data: data.sort((a, b) => b.value - a.value), //数组从大到小排序

            emphasis: {
              //启用鼠标放上去放大效果，这个挺好的
              scale: true,
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      this.pieEChart2 = echarts.init(document.getElementById('chart4'));
      this.pieEChart2.setOption(option, true);
    },
    initLine() {
      let dataName = [];
      let data = [];
      this.monthScore.forEach((item) => {
        dataName.push(item.label);
        data.push(item.value);
      });
      let option = {
        backgroundColor: 'transparent',
        title: {
          text: '万元',
          textStyle: {
            color: '#ffffff',
            fontSize: 12,
          },
          top: '4%',
          left: '2%',
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // 获取当前悬停的系列数据
            var tooltipContent = params
              .map((item) => {
                return `${item.value} 万元`; // 在数字后面加上“万元”
              })
              .join('<br/>'); // 使用换行符分隔不同系列
            return tooltipContent;
          },
        },
        legend: {
          data: ['月份', '总金额'],
          icon: 'rich',
          show: true,
          itemWidth: 18,
          itemHeight: 2,
          textStyle: {
            color: '#AFBDD1',
            fontSize: '12px',
          },
          top: 8,
          right: 10,
          itemGap: 34,
        },
        grid: {
          left: '4%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true,
        },
        xAxis: {
          data: dataName,
          type: 'category',
          boundaryGap: false,
          axisLine: {
            symbol: 'none',
            lineStyle: {
              color: '#50637A',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            color: '#ffffff',
            fontSize: 12,
            padding: [10, 0, 0, 0],
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#ffffff',
            fontSize: 12,
            padding: [0, 10, 0, 0],
          },
          splitLine: {
            lineStyle: {
              color: '#50637A',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            // name: '增加值',
            data: data,
            type: 'line',
            smooth: true,
            color: '#00F7FF',
            lineStyle: {
              width: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: 'rgba(0, 247, 255, .6)',
                  },
                  {
                    offset: 0.8,
                    color: 'rgba(0, 247, 255, .2)',
                  },
                ],
                false
              ),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10,
            },
            symbol: 'circle',
            symbolSize: 6,
          },
        ],
      };
      this.lineEChart = echarts.init(document.getElementById('chart5'));
      this.lineEChart.setOption(option, true);
    },
    initBar1() {
      let dataName = [];
      let data = [];
      function normalizeName(name) {
        return name
          .replace(/市$/, '') // 去掉“市”后缀
          .replace(/省$/, '') // 去掉“省”后缀
          .replace(/自治区$/, '') // 去掉“自治区”后缀
          .replace(/特别行政区$/, '') // 去掉“特别行政区”后缀
          .replace(/回族$/, '') // 去掉“回族自治区”后缀
          .replace(/壮族$/, '')
          .replace(/维吾尔$/, '');
      }
      this.provinceScore.forEach((item) => {
        dataName.push(normalizeName(item.label));
        data.push(item.value);
      });
      var option = (option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            // 获取当前悬停的系列数据
            var tooltipContent = params
              .map((item) => {
                return `${item.name}<br>${item.value} 万元`; // 在数字后面加上“万元”
              })
              .join('<br/>'); // 使用换行符分隔不同系列
            return tooltipContent;
          },
        },
        grid: {
          top: '8%',
          right: '5%',
          left: '10%',
          bottom: '50%',
        },
        xAxis: [
          {
            type: 'category',
            data: dataName,
            axisLine: {
              lineStyle: {
                color: '#50637A',
              },
            },
            axisLabel: {
              margin: 10,
              color: '#ffffff',
              textStyle: {
                fontSize: 14,
              },
              interval: 0, // 显示所有标签
              rotate: this.provinceScore.length > 10 ? 45 : 0, // 根据条件设置旋转角度
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '万元 ',
            nameTextStyle: {
              color: '#A1A7B3',
              fontSize: 14,
              align: 'right',
              padding: 5,
            },
            axisLabel: {
              formatter: '{value}',
              color: '#ffffff',
              fontSize: 14,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(173, 216, 230, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            type: 'bar',
            data: data,
            barWidth: '12px',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#0DBBF2',
                },
                {
                  offset: 1,
                  color: '#4223FD',
                },
              ]),
              barBorderRadius: [12, 12, 0, 0], // 设置顶部为半圆
            },
          },
        ],
      });

      this.column1EChart = echarts.init(document.getElementById('chart6'));
      this.column1EChart.setOption(option, true);
    },
    initBar2() {
      let dataName = [];
      let data = [];
      this.cityScore.forEach((item) => {
        dataName.push(item.label);
        data.push(item.value);
      });
      var option = (option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            // 获取当前悬停的系列数据
            var tooltipContent = params
              .map((item) => {
                return `${item.name}<br>${item.value} 万元`; // 在数字后面加上“万元”
              })
              .join('<br/>'); // 使用换行符分隔不同系列
            return tooltipContent;
          },
        },
        grid: {
          top: '8%',
          right: '5%',
          left: '10%',
          bottom: '50%',
        },
        xAxis: [
          {
            type: 'category',
            data: dataName,
            axisLine: {
              lineStyle: {
                color: '#50637A',
              },
            },
            axisLabel: {
              margin: 10,
              color: '#ffffff',
              textStyle: {
                fontSize: 14,
              },
              interval: 0, // 显示所有标签
              rotate: this.cityScore.length > 6 ? 45 : 0, // 根据条件设置旋转角度
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '万元 ',
            nameTextStyle: {
              color: '#C1C6CF',
              fontSize: 14,
              align: 'right',
              padding: 5,
            },
            axisLabel: {
              formatter: '{value}',
              color: '#ffffff',
              fontSize: 14,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(173, 216, 230, 0.5)',
                type: 'dashed',
              },
            },
          },
        ],
        series: [
          {
            type: 'bar',
            data: data,
            barWidth: '12px',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#be1185',
                },
                {
                  offset: 1,
                  color: '#750c56',
                },
              ]),
              barBorderRadius: [12, 12, 0, 0], // 设置顶部为半圆
            },
          },
        ],
      });

      this.column2EChart = echarts.init(document.getElementById('chart7'));
      this.column2EChart.setOption(option, true);
    },
  },
};
</script>
<style scoped>
.map {
  width: 100%;
  height: 600px;
}
.select-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: relative;
}
.back {
  position: absolute;
  right: 40px;
  border-radius: 6px;
  width: 140px;
  height: 32px;
  line-height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 13px;
  letter-spacing: 1px; /* 增加字母之间的间距 */
  text-align: center;
  background-color: rgb(64, 158, 255);
  cursor: pointer;
}
.back img {
  margin-right: 6px;
}

/* 直接针对 el-select 组件的背景颜色 */
/deep/.custom-select .el-input__inner {
  background-color: transparent !important; /* 蓝色背景 */
  color: white; /* 字体颜色为白色 */
  width: 110px;
  border-radius: 40px;
  border: 1px solid rgba(147, 235, 248, 1); /* 去掉边框 */
}
</style>
<style lang="scss" scoped>
.static-view {
  width: 100%;
  height: calc(100vh - 60px);
  overflow-y: auto;
  background-image: url('../../../assets/img/dataBg.png');
  background-size: cover;
  /* 使用 cover */
  background-position: center;
  /* 居中显示 */

  &-header {
    display: flex;
    padding: 20px 0;

    &-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: center;

      .header-title {
        margin: 0 20px;
        background-size: 100% 100%;
        flex: 1;
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bolder;
        font-family: cursive;
        line-height: 1;
        color: #fafcff;
      }

      .header-line {
        width: 98%;
        margin-left: 1%;
        position: absolute;
        top: -6px;
        height: 100px;
        background-image: url('../../../assets/img/dataLine.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }
}

.echarts {
  display: flex;

  .title {
    font-size: 16px;
    color: #fffafd;
    position: relative;
    line-height: 40px;
    font-weight: bolder;

    .title-img {
      position: absolute;
      top: 0;
      left: 0;
      height: 40px;
    }
  }

  .mapLeft {
    width: 28%;
    padding-left: 20px;

    .mapLeftTop {
      margin-left: 30px;
      height: 340px;

      .title {
        width: 180px;

        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 180px;
        }
      }

      .chart1 {
        margin-top: 10px;
        width: 460px;
        height: 430px;
      }
    }

    .mapLeftMiddle {
      margin-top: 60px;
      margin-left: 30px;

      .title {
        width: 220px;

        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 220px;
        }
      }

      .chart2 {
        margin-top: 10px;
        margin-left: -20px;
        width: 460px;
        height: 200px;
      }
    }

    .mapLeftBottom {
      margin-left: 30px;
      display: flex;

      .title {
        width: 150px;

        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 150px;
        }
      }

      .title1 {
        position: relative;
        font-size: 16px;
        color: #fafcff;
        margin-left: 40px;
        width: 150px;
        line-height: 40px;

        /* 设置行高与标题线的高度相同 */
        .title-img {
          position: absolute;
          top: 0;
          left: 0;
          height: 40px;
          width: 150px;
        }
      }

      .chart3 {
        margin-top: 30px;
        margin-left: -30px;
        width: 240px;
        height: 180px;
      }

      .chart4 {
        margin-top: 30px;
        margin-left: 20px;
        width: 240px;
        height: 180px;
      }
    }
  }

  .mapMiddle {
    width: 44%;

    .mapMiddleFooter {
      display: flex;
      justify-content: space-around;

      .footerBtn {
        position: relative;
        font-size: 20px;
        color: #00cde8;
        display: flex;
        height: 100px;
        text-align: center;
        margin-left: 10px;
        width: 22%;
        margin-top: 40px;

        .text-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 160px;
          background-image: url('../../../assets/img/dataBtn.png');
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }

  .mapRight {
    width: 28%;

    .mapRightTop {
      margin-top: 20px;
      margin-left: 40px;
      // height: 250px;

      .title {
        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 220px;
        }
      }

      .chart5 {
        // margin-top: 10px;
        margin-left: -10px;
        width: 480px;
        height: 240px;
      }
    }

    .mapRightMiddle {
      margin-left: 40px;
      height: 330px;
      margin-top: 10px;

      .title {
        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 130px;
        }
      }

      .chart6 {
        margin-top: 10px;
        margin-left: 0px;
        width: 460px;
        height: 430px;
      }
    }

    .mapRightBottom {
      margin-left: 40px;
      height: 320px;
      overflow: hidden;

      .title {
        /* 设置行高与标题线的高度相同 */
        .title-img {
          width: 130px;
        }
      }

      .chart7 {
        margin-top: 10px;
        margin-left: 0px;
        width: 460px;
        height: 430px;
      }
    }
  }
}

// .lager-view {
//   height: 100vh;

//   .static-view-echarts {
//     height: 78%;
//   }
// }
</style>
